import { Component, Input, Output, EventEmitter } from '@angular/core'

import { LabelFilter } from './label-filter'

@Component({
  selector: 'label-filters',
  template: require('./label-filters.component.html')
})

export class LabelFiltersComponent {
  @Input() private filters: LabelFilter[] = []

  @Output('onRemoveFilter') onRemoveFilterEmitter = new EventEmitter<LabelFilter>()

  constructor() {}

  private removeFilter(filter: LabelFilter) {
    this.onRemoveFilterEmitter.emit(filter)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/common/search/label-filters.component.ts